import React from "react";

interface Props {
  index: number;
  url: string;
  success: boolean;
  content: string;
  deleteResult: (index: number) => void;
}

export default function AICrawlResult(props: Props) {
  const [expanded, setExpanded] = React.useState(false);
  let angleClassName = "ml-1 transition fa-solid fa-angle-down";

  if (expanded === true) {
    angleClassName += " rotate-180";
    //bgClass = "bg-blue-50 dark:bg-stone-400 dark:text-white hover:bg-blue-100";
  }

  return (
    <div className="flex flex-col">
      <div className="flex flex-row">
        <div className="pl-1 pr-2">
          <button
            className=" text-slate-gray-400 hover:text-red-500"
            onClick={() => props.deleteResult(props.index)}
          >
            <i className="fa-solid fa-trash"></i>
          </button>
        </div>
        <div className="pr-2 font-semibold">{props.index + 1}.</div>
        <div className="text-sm font-bold">{props.url}</div>
        <div
          className={`"ml-2 pl-2 text-sm font-semibold " ${
            props.success ? "text-green-500" : "text-red-500"
          }`}
        >
          {props.success ? "Success" : "Failure"}
        </div>
        <button
          className={`flex flex-row items-center justify-center"`}
          onClick={() => {
            setExpanded(!expanded);
          }}
        >
          <div className="text-slate-gray-500 text-xs font-semibold font-['Rubik'] leading-none">
            <i className={angleClassName}></i>
          </div>
        </button>
      </div>
      {expanded && (
        <textarea
          className="mt-2 border-black border rounded-md text-sm w-full h-72 py-2"
          value={props.content}
        ></textarea>
      )}
    </div>
  );
}
